import {IconButton, Menu, TableCell, TableRow, Tooltip} from "@mui/material";
import React, {Component} from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {ScreenshotUserActions} from "./Actions";
import moment from "moment-timezone";
import styles from "../Message-V2/Styles.module.css";

export class ScreenshotRow extends Component{

    state = {
        anchorElement: null,
    };

    /**
     * Identifies the clicked item and opens the popup menu for the three dots
     * @param event
     */
    handleClick = event => {
        this.setState({anchorElement: event.currentTarget});
    };

    /**
     * Responsible for closing the popup menu
     */
    handleClose = () => {
        this.setState({anchorElement: null});
    };

    render(){

        const {screenshot} = this.props;
        const {message: {text, id}, dateCreated, submittedBy, submittedFor} = screenshot;
        const zone_name =  moment.tz.guess();
        const timezone = moment.tz(zone_name).zoneAbbr();

        const { anchorElement } = this.state;
        const open = Boolean(anchorElement);
        let reporterName;
        let agentName;
        if (submittedFor) {
            const firstName = submittedFor.firstName;
            const lastName = submittedFor.firstName;
            agentName = firstName || lastName ? `${firstName ? firstName : ''} ${lastName ? lastName : ''}` : submittedFor.username;
        }

        if (submittedBy) {
            const firstName = submittedBy.firstName;
            const lastName = submittedBy.lastName;
            reporterName = firstName || lastName ? `${firstName ? firstName : ''} ${lastName ? lastName : ''}` : submittedBy.username;
        }

        const agentUsername = submittedFor ? submittedFor.username : ''

        return (
            <TableRow>
                <Tooltip title={text} enterDelay={700} placement='bottom-start'>
                    <TableCell sx={{ maxWidth: '250px'}} className={styles.tableCell}>
                        <a href={`messages/${id}?platform=teams-only`} className="tms-no-underline">
                            <span className={`font-14 truncate-string ${styles["typography14"]}}`} >{text}</span>
                        </a>
                    </TableCell>
                </Tooltip>
                <TableCell className={styles.tableCell}>
                        <span className={styles.typography15}>{agentName}</span>
                </TableCell>
                <TableCell className={styles.tableCell}>
                        <span className={styles.typography15}>{agentUsername}</span>
                </TableCell>
                <TableCell className={styles.tableCell}>
                        <span className={styles.typography15}>{reporterName ? reporterName : ''}</span>
                </TableCell>
                <TableCell className={styles.tableCell}>
                        <span className={styles.typography15}>
                            {`${moment(dateCreated).format('MMM DD hh:mm A z ')} ${timezone}`}
                        </span>
                </TableCell>
                <TableCell className={styles.tableCell}>
                    <IconButton
                        aria-label="More"
                        aria-owns={open ? 'long-menu' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleClick}
                        sx={{padding: "5px"}}
                    >
                        <MoreVertIcon size="small"/>
                    </IconButton>
                    <Menu
                        id="long-menu"
                        anchorEl={anchorElement}
                        open={open}
                        onClose={this.handleClose}
                    >
                        <ScreenshotUserActions
                            screenshot={screenshot}
                            handleClose={this.handleClose}
                        />
                    </Menu>
                </TableCell>
            </TableRow>
        )
    }
}
